import { TFunction } from "next-i18next";

import { WorkingArea } from "@utils/_types";

export const workingAreasToLabelDict = (
  t: TFunction,
): Record<WorkingArea, string> => ({
  embedded: t("working-areas.embedded"),
  automation: t("working-areas.automation"),
  agile: t("working-areas.agile"),
});
